import { c as _c } from "react/compiler-runtime";
import BookingDetail from '@/components/modules/BookingDetail';
import useCartCalculatedPrice from '@/contexts/cartContext/hooks/useCartCalcualtedPrice';
import { LoaderWithContainer } from '@winelidays/wld-tsx-2/elements';
import useTunnelBookingFilters from '../context/hooks/useTunnelBookingFilters';
import useTunnelExperience from '../context/hooks/useTunnelExperience';
const BookingSticky = (t0) => {
    const $ = _c(8);
    const { addToCartButton, showCancellation: t1 } = t0;
    const showCancellation = t1 === undefined ? false : t1;
    const { experience } = useTunnelExperience();
    const { filters, completion, calculatedPrice: tunnelCalculatedPrice } = useTunnelBookingFilters();
    const cartCalculatedPrice = useCartCalculatedPrice();
    let t2;
    if ($[0] !== addToCartButton || $[1] !== cartCalculatedPrice || $[2] !== completion || $[3] !== experience || $[4] !== filters || $[5] !== showCancellation || $[6] !== tunnelCalculatedPrice) {
        t2 = experience ?
            <section className="flex flex-col overflow-hidden lg:rounded lg:shadow-modal">
      <BookingDetail filters={filters} completion={completion} entity={experience} calculatedPrice={cartCalculatedPrice ?? tunnelCalculatedPrice} cancellation={experience.cancellation} contentClassName="tunnel-padding-x-reduced-lg" addToCartButton={addToCartButton} showCancellation={showCancellation}/>

    </section> :
            <LoaderWithContainer />;
        $[0] = addToCartButton;
        $[1] = cartCalculatedPrice;
        $[2] = completion;
        $[3] = experience;
        $[4] = filters;
        $[5] = showCancellation;
        $[6] = tunnelCalculatedPrice;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    return t2;
};
export default BookingSticky;
